
import { Box, Grid, Link, Typography } from '@mui/material';
import Header, { Content } from '../components/Header';
import MediaCard from '../components/cards/MediaCard';

type CourseInfo = {
  courseName: string,
  courseDesc: string,
  courseImg: string,
  courseLink: string,
  isFree: boolean,
}

const courseInfos: CourseInfo[] = [
  {
    courseName: "Basic Programming 1: Intro and Variables",
    courseDesc: `In this course we will start with a short introduction to
      programming, followed by code comments and code conventions (styling).
      Then, we will go in-depth into variables, using TypeScript as a language`,
    courseImg: "bp-1-vars.png",
    courseLink: "https://www.udemy.com/course/coding-in-fun-basic-programming-1/?referralCode=B94A76AF1283C3C13ABA",
    isFree: true,
  },
  {
    courseName: "Object-Oriented and Scalable Designs in Depth",
    courseDesc: `In this course we will dive deep into object-oriented
      programming. We will cover multi-level inheritance, abstraction,
      polymorphism, and interfaces. As we go, we will learn how to
      use object-oriented to make good design choices that keep our
      design scalable. The course includes short quizzes, and a proprietary
      practice website.`,
    courseImg: "adv-oop.png",
    courseLink: "https://www.udemy.com/course/coding-in-fun-object-oriented-and-scalable-designs-in-depth/?referralCode=AADA22ED6DE4AEFD44D8",
    isFree: false,
  }
]

export default function CoursesPage(props: any) {
  return (
    <>
      <Header title="My Courses" />
      <Content>
        <Box pt={1}>
          <Box mb={1}>
            <Typography gutterBottom variant="h6" component="div">
              Free Courses
            </Typography>
          </Box>
          <Grid container spacing={4}>
            {courseInfos.map((e, idx) => e.isFree &&
              <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
                {CourseCard(e)}
              </Grid>
            )}
          </Grid>
          <Box mt={2} mb={1}>
            <Typography gutterBottom variant="h6" component="div">
              Paid Courses
            </Typography>
          </Box>
          <Grid container spacing={4}>
            {courseInfos.map((e, idx) => !e.isFree &&
              <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
                {CourseCard(e)}
              </Grid>
            )}
          </Grid>
        </Box>
      </Content>
    </>
  );
}

function CourseCard(courseInfo: CourseInfo) {
  return (
    <Link href={courseInfo.courseLink} target="_blank" underline="none">
      <MediaCard
        title={courseInfo.courseName}
        subtitle={courseInfo.courseDesc}
        imgSrc={"/img/courses/" + courseInfo.courseImg}
        mediaHeight={150}
      />
    </Link>
  );
}
